import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[500px] mx-auto py-6" }
const _hoisted_2 = { class: "col-span-2" }
const _hoisted_3 = { class: "flex items-center justify-end w-full space-x-3" }
const _hoisted_4 = { href: "/settings/baranagay/index/" }

import { ref, onMounted } from 'vue';
import UserLayout from '@/layouts/UserLayout.vue';
import FormSection from './FormSection.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import PageLoader from "@/components/loaders/PageLoader.vue"
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';

import { errorResponse } from "@/helpers/errorMessage";

import BarangayService from "@/classes/Settings/Locations/BarangayService";

import {
    LocationDataInterface,
    SelectInterface
} from "@/interfaces/Settings/LocationInterface"

import pickBy from "lodash/pickBy";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePage',
  setup(__props) {

const loading = ref<boolean>(false);
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const loaded = ref<boolean>(false);
const successMessage = ref<string>('');
const errors = ref<any>();

const form = ref<LocationDataInterface>({
    region_id: null,
    province_id: null,
    city_id: null,
    name: '',
    code: '',
});


const save = (): void => {
    loading.value = true; 

    BarangayService.store(form.value)
        .then((response: any) => {
            loading.value = false;
            successMessage.value = response.data.message;
            showSuccess.value = true;
            showConfirmation.value = false
        })
        .catch((error: any) => {
            loading.value = false;
            showConfirmation.value = false
            errors.value = errorResponse(error.response?.data?.errors)
        });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: "/settings/baranagay/index"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, {
          form: form.value,
          errors: errors.value
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("a", _hoisted_4, [
                  _createVNode(ButtonComponent, { btnWidth: "quinary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cancel")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(ButtonComponent, {
                  btnWidth: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showConfirmation.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Save Changes")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(ConfirmationModal, {
                typeTwo: true,
                show: showConfirmation.value,
                onCancel: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = false)),
                onConfirm: _cache[2] || (_cache[2] = ($event: any) => (save())),
                "cancel-text": "Cancel",
                "action-text": "Confirm",
                title: "Save Record",
                content: "Are you sure you wish to save this record?"
              }, null, 8, ["show"]),
              _createVNode(SuccessModal, {
                show: showSuccess.value,
                onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false, _ctx.$router.replace('/settings/barangay/index'))),
                "action-text": "Close",
                title: "Success!",
                content: successMessage.value
              }, null, 8, ["show", "content"])
            ])
          ]),
          _: 1
        }, 8, ["form", "errors"])
      ]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})